export default {
  inject: ['$section'],
  props: {
    list: Array,
  },
  data() {
    const products = (this.$section && this.$section.products) || this.list || [];
    const index = Math.floor(Math.random() * products.length);

    return {
      product: products[index],
    };
  },
};
